import React from 'react';
import { Alert, Button, Group } from '@mantine/core';
import {
    IconAlertCircle,
    IconAlertTriangle,
    IconInfoCircle,
} from '@tabler/icons-react';
import type { ErrorStateProps } from '../../theme/mantineTheme';

const SEVERITY_CONFIG = {
    error: { color: 'red' as const, icon: IconAlertCircle },
    warning: { color: 'yellow' as const, icon: IconAlertTriangle },
    info: { color: 'blue' as const, icon: IconInfoCircle },
};

/**
 * Unified error/warning/info state component.
 * Replaces ad-hoc <Alert color="red"> patterns across the app.
 */
export function ErrorState({
    severity,
    title,
    message,
    retryLabel,
    onRetry,
    onDismiss,
}: ErrorStateProps & { onDismiss?: () => void }) {
    const config = SEVERITY_CONFIG[severity];
    const Icon = config.icon;

    return (
        <Alert
            color={config.color}
            icon={<Icon size={16} />}
            title={title}
            radius="md"
            mb="md"
            withCloseButton={!!onDismiss}
            onClose={onDismiss}
        >
            {message}
            {retryLabel && onRetry && (
                <Group mt="sm">
                    <Button
                        variant="light"
                        color={config.color}
                        size="xs"
                        onClick={onRetry}
                    >
                        {retryLabel}
                    </Button>
                </Group>
            )}
        </Alert>
    );
}
